const chartColor = {
  0: '#008FFB',
  1: '#00E396',
  2: '#FEB019',
  3: '#FF4560',
  4: '#775DD0'
};

export { chartColor };
